import { isDate } from 'moment';
import { apiSlice } from '../../../../app/apiSlice';
import { Noticia, NoticiaDTO, NoticiaList } from '../../../../typesSite/noticia/Noticia';
import configSiteUrls from '../../configs/configSiteUrls';
//usei o noticia como base

const endpointUrl = configSiteUrls.SITE_NOTICIA_EP;
const endpointUrlPublic = configSiteUrls.SITE_NOTICIA_PUBLIC_EP;

function getNoticias({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function addNoticia(obj: NoticiaDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deleteNoticia({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getNoticia({ id, isPublicLink = false }: { id: string; isPublicLink?: boolean }) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${isPublicLink ? endpointUrlPublic : endpointUrl}/${id}`,
    method: 'GET'
  };
}

/** */

export const noticiaApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getNoticias: query<NoticiaList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getNoticias,
      providesTags: ['NoticiaSite']
    }),

    getNoticia: query<Noticia, { id: string; isPublicLink?: boolean }>({
      query: ({ id, isPublicLink = false }) => getNoticia({ id, isPublicLink }),
      providesTags: ['NoticiaSite']
    }),
    addNoticia: mutation<Noticia, NoticiaDTO>({
      query: addNoticia,
      invalidatesTags: ['NoticiaSite']
    }),
    deleteNoticia: mutation<void, { id: string }>({
      query: deleteNoticia,
      invalidatesTags: ['NoticiaSite']
    })
  })
});
export const { useGetNoticiasQuery, useGetNoticiaQuery, useAddNoticiaMutation, useDeleteNoticiaMutation } =
  noticiaApiSlice;
